import axios from 'axios'

export function injectTokenInterceptor($toasted, forceLogout = true) {
    let token = localStorage.getItem('accessToken') || null

    if (!token) {
        localStorage.removeItem('accessToken')
        localStorage.removeItem('accountFullName')
        localStorage.removeItem('accountId')
        if (forceLogout)  {
            $toasted.error('Z důvodu dlouhodobé nečinnosti jste byli odhlášeni.', {
                position: 'top-center',
                fullWidth: true,
                fitToScreen: false,
                duration: 3000,
                onComplete: () => window.location = '/'
            })
        }
    }

    axios.interceptors.response.use(response => response, error => {
        if (error) {
            if (error.response && 401 === error.response.status) {
                localStorage.removeItem('accessToken')
                localStorage.removeItem('accountFullName')
                localStorage.removeItem('accountId')
                if (forceLogout) {
                    window.location = '/'
                } else {
                    // window.location.reload(true)
                }
            } else {
                return Promise.reject(error);
            }
        }
    })

    axios.interceptors.request.use(
        config => {
            if (!token) {
                token = localStorage.getItem('accessToken') || null
            }
            if (token) {
                // config.baseURL = API_URL
                config.headers = {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }
            return config;
        },
        error => Promise.reject(error)
    )

    return token
}
